import styled from 'styled-components';

import { Header, Text as TextLayout } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  flex: 1;
`;

export const Center = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const SectionHeader = styled(Center)`
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 25px;
  max-width: 680px;
  align-self: center;
  @media (max-width: 768px) {
    max-width: 100%
  }
`;

export const Text = styled(Header)`
  margin: 5px 0px;
  margin-left: 6em;
  @media (max-width: 768px) {
    margin-left: 0;
    text-align: center;
  }
`;

export const TextPrimary = styled(TextLayout)`
  margin-left: 7em;
  @media (max-width: 768px) {
    margin-left: 0;
    text-align: center;
  }
`;
